import {useAuth0} from '@auth0/auth0-react';
import {Button, Card, CardActions, CardContent, CardHeader, Container, Typography} from '@mui/material';

const AccountDisabled = () : JSX.Element => {
    const {logout} = useAuth0();

    return (
        <Container sx={{my: 2}}>
            <Card variant="outlined" sx={{backgroundColor: 'grey.100'}}>
                <CardHeader title="Account disabled"/>
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        Your account is currently not allowed to access the BLUE HAWK mobile app.
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" onClick={() => {
                        logout({
                            logoutParams: {
                                returnTo: window.location.origin,
                            },
                        });
                    }}>
                        Return to Login
                    </Button>
                </CardActions>
            </Card>
        </Container>
    );
};

export default AccountDisabled;
